<ng-template #defaultTabButtons let-c="close" let-d="dismiss">
    <div class=" text-white backgroundTable">

        <div class=" mx-5 ">
            <div class="row my-2">
              <div class="col-9 align-self-center p-2 bd-highlight">Terminar Asignación</div>
              
              <div class="col-3 d-flex flex-row-reverse bd-highlight p-2 "><button type="button" ngbAutofocus aria-label="Close"  (click)="d('Cross click')" class="btn btn-outline-danger "><i class="fa-solid fa-xmark fa-xl"></i></button></div>
            </div>
          </div>
        
        <div class="componente-importantes-from componente-importantes-from-popup" >
            <form
                action=""
                method="post"
                (submit)="formSubmitt()"
                [formGroup]="endAssignmentForm"
                class="mx-4">
            
                <label for="formControlInput" class="form-label mt-1">Si esta seguro de esta acción, Seleccione una fecha de término y presione confirmar</label>

                <div class="form-group px-3 pb-3">
                    <label for="formControlInput" class="form-label mt-1">Fecha Término</label>
                    <input type="date" required class="form-control custom-outline-input" id="end"
                    formControlName="end">
                
                </div>
            <br>
            <div class="col-12 mt-3 d-flex justify-content-center pb-4">
                <button class="btn btn-outline-light ">Confirmar</button>
            </div>
            </form>
        </div>
    </div>

</ng-template>

